<button type='submit' class='btn btn-primary btn-block'
	id="{{idValue}}" [disabled]='disabled || submitPending'>
	{{labelButton}}
	<span spinner [disable]="disableSpinner"></span>
</button>
